<listbox-empty>
  <ng-container text>
    {{ "GROUPS.LIST.NO_INVITATIONS" | translate }}
  </ng-container>
</listbox-empty>
